module.exports = __webpack_public_path__ + "img/screen-sharing.9f3dd21b.svg";